import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlatform = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 750,
	height: 341,
	viewBox: "0 0 750 341",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: "platform-svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M374.005 187.888L544.488 234.383L374.482 286.93L204 234.253L374.005 187.888Z",
			fill: "#E4D8F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M204.477 234.384V259.112L374.482 311.659V286.931L204.477 234.384ZM544.488 234.384V259.112L374.482 311.659V286.931L544.488 234.384Z",
			fill: "#C2B3D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M204.477 234.384V259.112L374.482 311.659V286.931L204.477 234.384ZM544.488 234.384V259.112L374.482 311.659V286.931L544.488 234.384Z",
			fill: "url(#paint0_linear_2669_33617)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M170.005 100.287L340.488 146.782L170.482 199.329L-0.000459191 146.652L170.005 100.287Z",
			fill: "#E4D8F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.476562 146.782V171.51L170.482 224.057V199.329L0.476562 146.782ZM340.488 146.782V171.51L170.482 224.057V199.329L340.488 146.782Z",
			fill: "#C2B3D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.476562 146.782V171.51L170.482 224.057V199.329L0.476562 146.782ZM340.488 146.782V171.51L170.482 224.057V199.329L340.488 146.782Z",
			fill: "url(#paint1_linear_2669_33617)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M579.005 100.287L749.488 146.782L579.482 199.329L409 146.652L579.005 100.287Z",
			fill: "#E4D8F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M409.477 146.782V171.51L579.482 224.057V199.329L409.477 146.782ZM749.488 146.782V171.51L579.482 224.057V199.329L749.488 146.782Z",
			fill: "#C2B3D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M409.477 146.782V171.51L579.482 224.057V199.329L409.477 146.782ZM749.488 146.782V171.51L579.482 224.057V199.329L749.488 146.782Z",
			fill: "url(#paint2_linear_2669_33617)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M374.285 27.8816L528 69.8036L374.715 117.183L221 69.6866L374.285 27.8816Z",
			fill: "#E4D8F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M221.43 69.8027V92.0987L374.715 139.478V117.182L221.43 69.8027ZM528 69.8027V92.0987L374.715 139.478V117.182L528 69.8027Z",
			fill: "#C2B3D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M221.43 69.8027V92.0987L374.715 139.478V117.182L221.43 69.8027ZM528 69.8027V92.0987L374.715 139.478V117.182L528 69.8027Z",
			fill: "url(#paint3_linear_2669_33617)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309 58L338.5 39L350.5 53L359 41.5L374 26.5L388 33L399.5 24L406.5 26.5L431.5 2",
			stroke: "#FF5789",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M310 78.5L349 66.5L362.5 57.5L372.5 42L394 13.5L439 31",
			stroke: "#815CA0",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M622 105.732C622 128.928 603.196 147.732 580 147.732C556.804 147.732 538 128.928 538 105.732C538 82.5365 556.804 63.7324 580 63.7324C603.196 63.7324 622 82.5365 622 105.732ZM554.288 105.732C554.288 119.933 565.8 131.444 580 131.444C594.2 131.444 605.712 119.933 605.712 105.732C605.712 91.5321 594.2 80.0204 580 80.0204C565.8 80.0204 554.288 91.5321 554.288 105.732Z",
			fill: "#B962BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M622 105.732C622 96.596 619.021 87.7088 613.514 80.4183C608.007 73.1279 600.274 67.8319 591.486 65.3334C582.697 62.8349 573.334 63.2702 564.816 66.5733C556.297 69.8764 549.088 75.8671 544.282 83.637C539.475 91.4069 537.333 100.532 538.181 109.629C539.029 118.726 542.82 127.299 548.979 134.047C555.138 140.795 563.33 145.351 572.312 147.023C581.294 148.695 590.577 147.393 598.752 143.314L591.48 128.739C586.475 131.237 580.792 132.034 575.294 131.01C569.795 129.986 564.78 127.197 561.009 123.066C557.239 118.935 554.918 113.687 554.399 108.118C553.88 102.549 555.191 96.9625 558.134 92.2058C561.076 87.4492 565.489 83.7817 570.704 81.7596C575.919 79.7375 581.651 79.471 587.031 81.0005C592.411 82.5301 597.146 85.7722 600.517 90.2354C603.888 94.6985 605.712 100.139 605.712 105.732H622Z",
			fill: "#7253A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M622 105.732C622 98.8255 620.297 92.0251 617.041 85.9338C613.785 79.8424 609.077 74.648 603.334 70.8107C597.591 66.9734 590.99 64.6117 584.117 63.9347C577.243 63.2577 570.308 64.2863 563.927 66.9295C557.546 69.5727 551.915 73.7488 547.534 79.0879C543.152 84.427 540.154 90.7644 538.807 97.5386C537.46 104.313 537.804 111.315 539.809 117.924C541.813 124.534 545.418 130.547 550.302 135.431L561.819 123.914C558.829 120.924 556.623 117.243 555.395 113.196C554.168 109.15 553.957 104.863 554.782 100.716C555.607 96.5692 557.442 92.6895 560.124 89.4209C562.807 86.1524 566.254 83.5958 570.16 81.9777C574.067 80.3595 578.312 79.7298 582.52 80.1443C586.728 80.5587 590.769 82.0045 594.285 84.3537C597.801 86.7028 600.683 89.8828 602.676 93.6119C604.669 97.341 605.712 101.504 605.712 105.732H622Z",
			fill: "#F0968A"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2669_33617)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 328,
					y: 133,
					width: 92,
					height: 107.422,
					rx: 5,
					fill: "#331B46"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328,
					y: 133,
					width: 92,
					height: 107.422,
					rx: 5,
					fill: "black",
					fillOpacity: .2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M336.715 158.759C336.407 158.759 336.117 158.714 335.844 158.625C335.576 158.53 335.352 158.389 335.174 158.2L335.583 157.508L335.613 157.448L335.68 157.486C335.69 157.52 335.702 157.558 335.717 157.597C335.737 157.637 335.777 157.684 335.836 157.739C335.96 157.833 336.097 157.91 336.246 157.969C336.4 158.024 336.566 158.054 336.745 158.059C336.859 158.059 336.963 158.046 337.057 158.022C337.157 157.997 337.241 157.96 337.31 157.91C337.38 157.86 337.434 157.798 337.474 157.724C337.514 157.644 337.534 157.555 337.534 157.456C337.534 157.396 337.526 157.339 337.511 157.285C337.497 157.23 337.469 157.178 337.43 157.128C337.395 157.074 337.343 157.021 337.273 156.972C337.204 156.917 337.117 156.86 337.013 156.801C336.908 156.736 336.777 156.669 336.618 156.6C336.3 156.461 336.047 156.319 335.859 156.175C335.675 156.031 335.543 155.877 335.464 155.714C335.385 155.55 335.345 155.364 335.345 155.155C335.345 154.927 335.407 154.723 335.531 154.545C335.66 154.366 335.836 154.225 336.06 154.12C336.283 154.016 336.539 153.964 336.826 153.964C337.02 153.964 337.201 153.986 337.37 154.031C337.539 154.076 337.695 154.143 337.839 154.232C337.983 154.316 338.114 154.426 338.234 154.56L337.742 155.125L337.698 155.178L337.638 155.133C337.633 155.093 337.623 155.056 337.608 155.021C337.598 154.982 337.566 154.932 337.511 154.872C337.417 154.783 337.315 154.723 337.206 154.694C337.102 154.664 336.978 154.649 336.834 154.649C336.73 154.649 336.638 154.661 336.558 154.686C336.479 154.711 336.41 154.746 336.35 154.79C336.295 154.835 336.251 154.887 336.216 154.947C336.186 155.001 336.171 155.058 336.171 155.118C336.171 155.178 336.179 155.235 336.194 155.289C336.209 155.339 336.233 155.389 336.268 155.438C336.308 155.488 336.362 155.54 336.432 155.594C336.506 155.644 336.601 155.699 336.715 155.758C336.829 155.818 336.97 155.885 337.139 155.959C337.372 156.068 337.569 156.175 337.727 156.279C337.886 156.379 338.01 156.485 338.1 156.6C338.194 156.709 338.261 156.83 338.301 156.964C338.34 157.093 338.36 157.24 338.36 157.404C338.36 157.627 338.303 157.843 338.189 158.051C338.075 158.26 337.896 158.431 337.653 158.565C337.41 158.694 337.097 158.759 336.715 158.759ZM339.015 158.677V154.038H342.038V154.723H339.834V155.915H341.643V156.607H339.834V157.992H342.016V158.677H339.015ZM342.783 154.038H343.624H343.698V154.105C343.669 154.135 343.649 154.168 343.639 154.202C343.634 154.237 343.631 154.297 343.631 154.381V157.992H345.761V158.677H342.783V154.038ZM346.46 158.677V154.038H349.483V154.723H347.279V155.915H349.089V156.607H347.279V157.992H349.461V158.677H346.46ZM351.88 158.759C351.627 158.759 351.389 158.714 351.166 158.625C350.942 158.53 350.744 158.386 350.57 158.193C350.401 157.999 350.27 157.754 350.176 157.456C350.081 157.153 350.034 156.796 350.034 156.384C350.034 156.021 350.071 155.704 350.146 155.431C350.22 155.158 350.319 154.929 350.444 154.746C350.573 154.557 350.717 154.406 350.875 154.292C351.039 154.177 351.208 154.096 351.382 154.046C351.56 153.996 351.736 153.971 351.91 153.971C352.263 153.971 352.56 154.051 352.804 154.21C353.052 154.369 353.243 154.592 353.377 154.88L352.848 155.274L352.789 155.312L352.752 155.252C352.756 155.212 352.752 155.175 352.737 155.14C352.727 155.106 352.702 155.053 352.662 154.984C352.553 154.85 352.439 154.761 352.32 154.716C352.206 154.671 352.084 154.649 351.955 154.649C351.811 154.649 351.674 154.686 351.545 154.761C351.416 154.83 351.3 154.937 351.195 155.081C351.091 155.225 351.009 155.403 350.95 155.617C350.895 155.825 350.868 156.068 350.868 156.346C350.868 156.614 350.893 156.855 350.942 157.069C350.997 157.277 351.069 157.456 351.158 157.605C351.253 157.754 351.362 157.868 351.486 157.947C351.615 158.027 351.754 158.066 351.903 158.066C352.022 158.066 352.131 158.049 352.23 158.014C352.335 157.979 352.429 157.925 352.513 157.85C352.598 157.776 352.675 157.677 352.744 157.553L353.325 157.984C353.151 158.262 352.948 158.461 352.714 158.58C352.481 158.699 352.203 158.759 351.88 158.759ZM354.948 158.677V154.746H353.697V154.038H357.07V154.746H355.752V158.677H354.948Z",
					fill: "#EADCF5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 338.636,
					y: 165.439,
					width: 30.8439,
					height: 3.19075,
					rx: 1.59538,
					fill: "#5361F4"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 338.636,
					y: 172.885,
					width: 14.3584,
					height: 3.19075,
					rx: 1.59538,
					fill: "#11857E"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 338.636,
					y: 180.329,
					width: 22.8671,
					height: 3.19075,
					rx: 1.59538,
					fill: "#A549E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M335.404 195.37V190.732H338.293V191.409H336.156V192.534H337.891V193.211H336.156V195.37H335.404ZM338.971 195.37V190.732H340.437C340.82 190.732 341.13 190.789 341.368 190.903C341.611 191.012 341.79 191.171 341.904 191.38C342.018 191.583 342.075 191.821 342.075 192.094C342.075 192.263 342.038 192.432 341.964 192.601C341.894 192.769 341.795 192.921 341.666 193.055C341.537 193.189 341.383 193.29 341.204 193.36L342.202 195.37H341.316L340.378 193.442H339.819V195.37H338.971ZM339.819 192.742H340.497C340.735 192.742 340.914 192.687 341.033 192.578C341.152 192.464 341.212 192.31 341.212 192.117C341.212 191.993 341.184 191.883 341.13 191.789C341.08 191.69 341.001 191.61 340.891 191.551C340.787 191.491 340.656 191.461 340.497 191.461H339.819V192.742ZM344.234 195.459C343.852 195.459 343.532 195.365 343.274 195.177C343.021 194.988 342.827 194.715 342.693 194.358C342.564 194 342.5 193.566 342.5 193.055C342.5 192.553 342.564 192.127 342.693 191.774C342.827 191.417 343.021 191.144 343.274 190.955C343.532 190.762 343.852 190.665 344.234 190.665C344.612 190.665 344.927 190.762 345.18 190.955C345.438 191.144 345.632 191.417 345.761 191.774C345.895 192.127 345.962 192.553 345.962 193.055C345.962 193.566 345.895 194.003 345.761 194.365C345.632 194.722 345.438 194.995 345.18 195.184C344.927 195.368 344.612 195.459 344.234 195.459ZM344.234 194.775C344.423 194.775 344.582 194.712 344.711 194.588C344.845 194.459 344.947 194.268 345.016 194.015C345.091 193.757 345.128 193.434 345.128 193.047C345.128 192.685 345.091 192.377 345.016 192.124C344.947 191.871 344.845 191.68 344.711 191.551C344.582 191.417 344.423 191.35 344.234 191.35C344.046 191.35 343.884 191.417 343.75 191.551C343.616 191.68 343.512 191.871 343.438 192.124C343.368 192.377 343.333 192.685 343.333 193.047C343.333 193.434 343.368 193.757 343.438 194.015C343.512 194.268 343.616 194.459 343.75 194.588C343.884 194.712 344.046 194.775 344.234 194.775ZM346.319 195.37V190.732H347.056L347.957 192.861L348.858 190.724H349.595V195.37H348.865V192.132L348.136 193.836H347.726L347.041 192.139V195.37H346.319Z",
					fill: "#EADCF5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 338.636,
					y: 202.133,
					width: 22.8671,
					height: 3.19075,
					rx: 1.59538,
					fill: "#FF5789"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 364.162,
					y: 202.133,
					width: 15.9538,
					height: 3.19075,
					rx: 1.59538,
					fill: "#61C5D3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 382.774,
					y: 202.133,
					width: 15.9538,
					height: 3.19075,
					rx: 1.59538,
					fill: "#F7B54E"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M335.598 217.705L334.988 213.067H335.717L336.03 215.978L336.625 213.432H337.072L337.668 215.97L337.913 213.067H338.598L337.995 217.705H337.467L336.812 214.846L336.142 217.705H335.598ZM338.919 213.067H339.76H339.834V213.134C339.805 213.164 339.785 213.196 339.775 213.231C339.77 213.265 339.767 213.325 339.767 213.409V214.95H341.197V213.067H342.045H342.112V213.134C342.083 213.164 342.065 213.196 342.06 213.231C342.055 213.265 342.053 213.325 342.053 213.409V217.705H341.197V215.62H339.767V217.705H338.919V213.067ZM342.738 217.705V213.067H345.761V213.752H343.557V214.943H345.366V215.635H343.557V217.02H345.738V217.705H342.738ZM346.416 217.705V213.067H347.882C348.265 213.067 348.575 213.124 348.813 213.238C349.056 213.347 349.235 213.506 349.349 213.715C349.463 213.918 349.52 214.156 349.52 214.429C349.52 214.598 349.483 214.767 349.409 214.936C349.339 215.104 349.24 215.256 349.111 215.39C348.982 215.524 348.828 215.625 348.649 215.695L349.647 217.705H348.761L347.823 215.777H347.264V217.705H346.416ZM347.264 215.077H347.942C348.18 215.077 348.359 215.022 348.478 214.913C348.597 214.799 348.657 214.645 348.657 214.452C348.657 214.327 348.629 214.218 348.575 214.124C348.525 214.025 348.446 213.945 348.337 213.886C348.232 213.826 348.101 213.796 347.942 213.796H347.264V215.077ZM350.183 217.705V213.067H353.206V213.752H351.002V214.943H352.811V215.635H351.002V217.02H353.183V217.705H350.183Z",
					fill: "#EADCF5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 338.636,
					y: 226.341,
					width: 19.1445,
					height: 3.19075,
					rx: 1.59538,
					fill: "#11857E"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M361.786 229.669V228.872L364.138 227.547L361.801 226.37V225.603L365.01 227.308V227.763L361.786 229.669ZM370.824 230.026C370.502 230.026 370.209 229.964 369.946 229.84C369.688 229.716 369.489 229.532 369.35 229.289L369.938 228.805L369.998 228.76L370.035 228.812C370.035 228.852 370.042 228.889 370.057 228.924C370.072 228.959 370.104 229.008 370.154 229.073C370.243 229.162 370.343 229.229 370.452 229.274C370.561 229.319 370.683 229.341 370.817 229.341C370.926 229.341 371.028 229.321 371.122 229.281C371.216 229.237 371.296 229.175 371.36 229.095C371.43 229.016 371.484 228.922 371.524 228.812C371.564 228.703 371.584 228.586 371.584 228.462C371.584 228.323 371.564 228.199 371.524 228.09C371.489 227.976 371.437 227.879 371.368 227.8C371.303 227.715 371.221 227.651 371.122 227.606C371.028 227.562 370.918 227.539 370.794 227.539C370.7 227.539 370.606 227.554 370.511 227.584C370.417 227.609 370.33 227.648 370.251 227.703C370.176 227.753 370.107 227.82 370.042 227.904L369.529 227.77L369.7 225.298H372.179V225.976H370.4L370.333 227.025C370.392 226.996 370.459 226.968 370.534 226.944C370.608 226.914 370.685 226.894 370.765 226.884C370.844 226.869 370.918 226.862 370.988 226.862C371.196 226.862 371.385 226.896 371.554 226.966C371.723 227.03 371.869 227.13 371.993 227.264C372.117 227.393 372.211 227.554 372.276 227.748C372.345 227.941 372.38 228.16 372.38 228.403C372.38 228.735 372.311 229.023 372.172 229.266C372.038 229.51 371.854 229.698 371.621 229.832C371.392 229.961 371.127 230.026 370.824 230.026Z",
					fill: "#EADCF5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 326.937,
					y: 133,
					width: 93.0636,
					height: 13.8266,
					fill: "#593674"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M337.834 139.416C337.816 139.234 337.738 139.092 337.601 138.99C337.463 138.889 337.277 138.838 337.041 138.838C336.881 138.838 336.746 138.861 336.635 138.906C336.525 138.95 336.44 139.011 336.382 139.09C336.324 139.169 336.295 139.258 336.295 139.357C336.292 139.441 336.31 139.513 336.348 139.575C336.387 139.637 336.44 139.691 336.508 139.736C336.576 139.78 336.655 139.818 336.744 139.851C336.833 139.883 336.928 139.91 337.03 139.933L337.447 140.033C337.649 140.078 337.835 140.138 338.004 140.214C338.173 140.29 338.32 140.382 338.444 140.493C338.568 140.603 338.664 140.733 338.732 140.883C338.801 141.032 338.837 141.204 338.838 141.397C338.837 141.681 338.764 141.927 338.621 142.136C338.479 142.343 338.273 142.504 338.004 142.618C337.737 142.732 337.414 142.788 337.036 142.788C336.662 142.788 336.335 142.731 336.057 142.616C335.781 142.501 335.565 142.331 335.409 142.106C335.255 141.88 335.174 141.599 335.167 141.266H336.116C336.127 141.421 336.172 141.551 336.25 141.655C336.33 141.758 336.437 141.836 336.57 141.889C336.704 141.94 336.856 141.966 337.025 141.966C337.191 141.966 337.336 141.942 337.458 141.893C337.582 141.845 337.678 141.778 337.746 141.692C337.814 141.605 337.848 141.506 337.848 141.395C337.848 141.29 337.817 141.203 337.755 141.132C337.694 141.061 337.605 141 337.487 140.951C337.371 140.901 337.228 140.855 337.059 140.815L336.554 140.688C336.162 140.592 335.854 140.444 335.627 140.241C335.4 140.039 335.288 139.766 335.289 139.423C335.288 139.142 335.363 138.897 335.514 138.687C335.666 138.477 335.875 138.313 336.141 138.195C336.407 138.077 336.709 138.018 337.048 138.018C337.392 138.018 337.693 138.077 337.95 138.195C338.208 138.313 338.409 138.477 338.553 138.687C338.696 138.897 338.77 139.14 338.775 139.416H337.834ZM341.25 141.109H342.084L342.503 141.648L342.915 142.129L343.693 143.103H342.777L342.242 142.446L341.968 142.056L341.25 141.109ZM343.763 140.402C343.763 140.908 343.667 141.339 343.475 141.694C343.285 142.049 343.025 142.32 342.696 142.507C342.368 142.693 341.999 142.786 341.59 142.786C341.177 142.786 340.807 142.692 340.479 142.505C340.151 142.318 339.892 142.047 339.702 141.692C339.512 141.337 339.417 140.907 339.417 140.402C339.417 139.896 339.512 139.465 339.702 139.11C339.892 138.755 340.151 138.485 340.479 138.299C340.807 138.112 341.177 138.018 341.59 138.018C341.999 138.018 342.368 138.112 342.696 138.299C343.025 138.485 343.285 138.755 343.475 139.11C343.667 139.465 343.763 139.896 343.763 140.402ZM342.768 140.402C342.768 140.074 342.719 139.798 342.621 139.573C342.524 139.348 342.387 139.177 342.211 139.061C342.034 138.944 341.827 138.886 341.59 138.886C341.353 138.886 341.146 138.944 340.969 139.061C340.792 139.177 340.655 139.348 340.556 139.573C340.46 139.798 340.411 140.074 340.411 140.402C340.411 140.73 340.46 141.006 340.556 141.232C340.655 141.457 340.792 141.627 340.969 141.744C341.146 141.86 341.353 141.918 341.59 141.918C341.827 141.918 342.034 141.86 342.211 141.744C342.387 141.627 342.524 141.457 342.621 141.232C342.719 141.006 342.768 140.73 342.768 140.402ZM344.49 142.723V138.082H345.471V141.914H347.461V142.723H344.49Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 117.445,
			y: 98.9053,
			width: 10.7461,
			height: 14.8792,
			fill: "#E674B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 117.445,
			y: 113.784,
			width: 10.7461,
			height: 14.0526,
			fill: "#B962BB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 117.445,
			y: 127.837,
			width: 10.7461,
			height: 9.91945,
			fill: "#7253A3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 117.445,
			y: 137.757,
			width: 10.7461,
			height: 14.8792,
			fill: "#3A125A"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 134.804,
			y: 69.1465,
			width: 10.7461,
			height: 29.7584,
			fill: "#E674B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 134.804,
			y: 98.9053,
			width: 10.7461,
			height: 14.0526,
			fill: "#B962BB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 134.804,
			y: 112.957,
			width: 10.7461,
			height: 9.91945,
			fill: "#7253A3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 134.804,
			y: 122.877,
			width: 10.7461,
			height: 29.7584,
			fill: "#3A125A"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 152.164,
			y: 39.8945,
			width: 10.7461,
			height: 8.26621,
			fill: "#E674B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 152.164,
			y: 48.1611,
			width: 10.7461,
			height: 72.2365,
			fill: "#B962BB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 152.164,
			y: 120.397,
			width: 10.7461,
			height: 25.6252,
			fill: "#7253A3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 152.164,
			y: 146.022,
			width: 10.7461,
			height: 6.61297,
			fill: "#3A125A"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 169.522,
			y: 77.4131,
			width: 10.7461,
			height: 27.2785,
			fill: "#E674B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 169.522,
			y: 104.691,
			width: 10.7461,
			height: 14.8792,
			fill: "#B962BB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 169.522,
			y: 119.571,
			width: 10.7461,
			height: 19.8389,
			fill: "#7253A3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 169.522,
			y: 139.409,
			width: 10.7461,
			height: 13.2259,
			fill: "#3A125A"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 186.881,
			y: 28,
			width: 10.4187,
			height: 44.4532,
			fill: "#E674B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 186.881,
			y: 72.4531,
			width: 10.7461,
			height: 36.3713,
			fill: "#B962BB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 186.881,
			y: 108.824,
			width: 10.7461,
			height: 30.585,
			fill: "#7253A3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 186.881,
			y: 139.409,
			width: 10.7461,
			height: 13.2259,
			fill: "#3A125A"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 204.241,
			y: 88.7451,
			width: 10.7461,
			height: 6.94581,
			fill: "#E674B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 204.241,
			y: 95.6914,
			width: 10.7461,
			height: 14.8792,
			fill: "#B962BB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 204.241,
			y: 110.57,
			width: 10.7461,
			height: 19.8389,
			fill: "#7253A3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 204.241,
			y: 130.409,
			width: 10.7461,
			height: 22.2266,
			fill: "#3A125A"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2669_33617",
				x1: 204.477,
				y1: 267.072,
				x2: 541.293,
				y2: 302.721,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C9A9C4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C2B3D2",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2669_33617",
				x1: .476563,
				y1: 179.47,
				x2: 337.293,
				y2: 215.12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C9A9C4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C2B3D2",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_2669_33617",
				x1: 409.477,
				y1: 179.47,
				x2: 746.293,
				y2: 215.12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C9A9C4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C2B3D2",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_2669_33617",
				x1: 221.43,
				y1: 99.2758,
				x2: 525.119,
				y2: 131.419,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C9A9C4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C2B3D2",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_2669_33617",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 328,
					y: 133,
					width: 92,
					height: 107.422,
					rx: 5,
					fill: "white"
				})
			})
		] })
	]
});
export default SvgPlatform;
